// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__5h4Dl","overflowing":"ReadFullNote_overflowing__2E9SG"};